'use strict';

var cart = require('../cart/cart');

var updateMiniCart = true;
var location = window.location;
let isDesktop = require('../utilities/clientSideUtil').isIpad;

/**
 * Open Minicart flyout
 * @param {Object} event - Event
 * @param {boolean} isAddToCart - isAddToCart
 *
 */
function openMiniCartFlyout(event, isAddToCart) {
    var url = $('.minicart').data('action-url');
    var count = parseInt($('.minicart .minicart-quantity').text(), 10);

    if (count !== 0 && $('.minicart .popover.show').length === 0) {
        event.preventDefault();
        if (!updateMiniCart) {
            $('.minicart .popover').addClass('show');
            $('.minicart .popover').removeAttr('inert');
            $('.modal-background').show();
            $('body').addClass('overflow-hidden');
            $('.minicart').find('.minicart-header-section .close').focus();
            return;
        }

        $('.minicart .popover').addClass('show');
        $('.minicart .popover').removeAttr('inert');
        $('.modal-background').show();
        $('body').addClass('overflow-hidden');
        $('.minicart .popover').spinner().start();
        $.get(url, function (data) {
            $('.minicart .popover').empty();
            $('.minicart .popover').append(data);
            if (isAddToCart) {
                $('.minicart').find('.minicart-added-to-cart-title').removeClass('invisible');
            }
            updateMiniCart = false;
            $('.minicart').find('.quantity').inputSpinner();
            $('.quantity-form').removeClass('d-none');
            $.spinner().stop();
            $('.minicart').find('.minicart-header-section .close').focus();
        });
    }
}

module.exports = function () {
    cart();

    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-quantity').removeClass('d-none');
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    $('.minicart').on('click', function (event) {
        if (isDesktop()) {
            openMiniCartFlyout(event, false);
        }
    });
    // Refinements close
    $('body').on('click', '.modal-background, .minicart .popover button.close', function (event) {
        if (!$(event.target).parents('.delete-confirmation-header').length > 0) {
            $('.minicart .popover').removeClass('show');
            $('.minicart .popover').attr('inert', 'true');
            $('.modal-background').hide();
            $('body').removeClass('overflow-hidden');
            $('.minicart').find('.minicart-added-to-cart-title').addClass('invisible');
            $('.minicart-link').focus();
        }
    });
    $('body').on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });
    $('body').on('product:afterAddToCart', function (event) {
        updateMiniCart = true;
        openMiniCartFlyout(event, true);
        $('.minicart').find('.minicart-added-to-cart-title').removeClass('invisible');
    });
    $('body').on('cart:update', function () {
        updateMiniCart = true;
        if ($('.minicart .popover.show').length === 0) {
            $('.modal-background').hide();
            $('body').removeClass('overflow-hidden');
            $('.minicart').find('.minicart-added-to-cart-title').addClass('invisible');
        }
    });
};
